"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textSizeConstants = exports.statusTitles = exports.iconComponents = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("../icons");

var _LoadingStatusSpinner = require("./LoadingStatusSpinner");

var _interfaces = require("./interfaces");

var _core = require("@emotion/core");

var _statusTitles, _statusIconsSmall, _statusIconsLarge, _iconComponents, _textSizeConstants;

var statusTitles = (_statusTitles = {}, (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Positive, 'Success'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Warning, 'Warning'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Negative, 'Error'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Information, 'Information'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Waiting, 'Pending'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Unavailable, 'Not available'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Declined, 'Declined'), (0, _defineProperty2.default)(_statusTitles, _interfaces.Status.Loading, 'Loading'), _statusTitles);
exports.statusTitles = statusTitles;
var statusIconsSmall = (_statusIconsSmall = {}, (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Positive, function (props) {
  return (0, _core.jsx)(_icons.IconCheckCircleFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "green70",
    title: statusTitles[_interfaces.Status.Positive]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Warning, function (props) {
  return (0, _core.jsx)(_icons.IconAlertTriangleFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "yellow80",
    title: statusTitles[_interfaces.Status.Warning]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Negative, function (props) {
  return (0, _core.jsx)(_icons.IconAlertCircleFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "red70",
    title: statusTitles[_interfaces.Status.Negative]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Information, function (props) {
  return (0, _core.jsx)(_icons.IconInformationFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Information]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Waiting, function (props) {
  return (0, _core.jsx)(_icons.IconClockFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Waiting]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Unavailable, function (props) {
  return (0, _core.jsx)(_icons.IconPadlockFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Unavailable]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Declined, function (props) {
  return (0, _core.jsx)(_icons.IconMinusCircleFill, (0, _extends2.default)({
    size: _icons.IconSize.ExtraSmall,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Declined]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Loading, function (props) {
  return (0, _core.jsx)(_LoadingStatusSpinner.LoadingStatusSpinner, (0, _extends2.default)({
    size: 16,
    title: statusTitles[_interfaces.Status.Loading]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsSmall, _interfaces.Status.Neutral, null), _statusIconsSmall);
var statusIconsLarge = (_statusIconsLarge = {}, (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Positive, function (props) {
  return (0, _core.jsx)(_icons.IconCheckCircleFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "green70",
    title: statusTitles[_interfaces.Status.Positive]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Warning, function (props) {
  return (0, _core.jsx)(_icons.IconAlertTriangleFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "yellow80",
    title: statusTitles[_interfaces.Status.Warning]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Negative, function (props) {
  return (0, _core.jsx)(_icons.IconAlertCircleFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "red70",
    title: statusTitles[_interfaces.Status.Negative]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Information, function (props) {
  return (0, _core.jsx)(_icons.IconInformationFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Information]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Waiting, function (props) {
  return (0, _core.jsx)(_icons.IconClockFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Waiting]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Unavailable, function (props) {
  return (0, _core.jsx)(_icons.IconPadlockFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Unavailable]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Declined, function (props) {
  return (0, _core.jsx)(_icons.IconMinusCircleFill, (0, _extends2.default)({
    size: _icons.IconSize.Small,
    color: "neutral70",
    title: statusTitles[_interfaces.Status.Declined]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Loading, function (props) {
  return (0, _core.jsx)(_LoadingStatusSpinner.LoadingStatusSpinner, (0, _extends2.default)({
    size: 20,
    title: statusTitles[_interfaces.Status.Loading]
  }, props));
}), (0, _defineProperty2.default)(_statusIconsLarge, _interfaces.Status.Neutral, null), _statusIconsLarge);
var iconComponents = (_iconComponents = {}, (0, _defineProperty2.default)(_iconComponents, _interfaces.StatusIndicatorSize.Small, statusIconsSmall), (0, _defineProperty2.default)(_iconComponents, _interfaces.StatusIndicatorSize.Large, statusIconsLarge), _iconComponents);
exports.iconComponents = iconComponents;
var textSizeConstants = (_textSizeConstants = {}, (0, _defineProperty2.default)(_textSizeConstants, _interfaces.StatusIndicatorSize.Small, {
  fontSize: 'T100'
}), (0, _defineProperty2.default)(_textSizeConstants, _interfaces.StatusIndicatorSize.Large, {
  fontSize: 'T300'
}), _textSizeConstants);
exports.textSizeConstants = textSizeConstants;